import React, { useEffect, useState, useRef } from "react";
import Footer from "./include/Footer";
import Header from "./include/Header";
import Sidebar from "./include/Sidebar";
import Pagination from "./include/Pagination";
import DateRangePickerComp from "./DateRangePickerComp";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useParams } from "react-router-dom";
import Loader from "./include/Loader";

const api_baseurl = process.env.REACT_APP_BASE_URL_API

function CommissionSummary() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setQuery] = useState("");
  const [searchDateRange, setDateRange] = useState("");
  const [finalDateValue, setFinalDateValue] = useState("");
  const [order, setOrder] = useState("ASC");

  const tableRef = useRef(null);

  const params = useParams();
  let vendor_id  = atob(params.vendor_id);

  const sorting = (col)=>{

    if(order === 'ASC'){
      const sorted = data.result.sort((a,b) =>
      
      col=='service_completed' || col=='service_amount' || col=='service_commission'  || col=='product_sold' || col=='product_amuont' || col=='product_commission' || col=='total_commission'
         ?
         a[col].toLowerCase()-b[col].toLowerCase()
         :
         a[col].toLowerCase() > b[col].toLowerCase()? 1: -1
        
      );
      
     // setData(sorted)
      setOrder("DSC")
    }

    if(order==='DSC'){
      const sorted = data.result.sort((a,b)=>
      col=='service_completed' || col=='service_amount' || col=='service_commission'  || col=='product_sold' || col=='product_amuont' || col=='product_commission' || col=='total_commission'
          ?
          b[col].toLowerCase() - a[col].toLowerCase()
          :
          a[col].toLowerCase() < b[col].toLowerCase()? 1: -1
       
      );
    // setData(sorted)
      setOrder("ASC")
    }
  }

  function parentAlert(demoData) {
    setDateRange(demoData);
    setFinalDateValue(searchDateRange);
  }

  function getCalendarValue() {
    setFinalDateValue(searchDateRange);
    loadData(finalDateValue);
  }

  useEffect(() => {
    // console.log('chess ',finalDateValue)
    getCalendarValue();
    loadData(finalDateValue);
  }, []);

  function loadData(datefilter) {
    setLoading(true);
    fetch(
      api_baseurl+"commission_summary?vendor_id=" +
        vendor_id +
        "&date_range=" +
        datefilter
    ).then((res) => {
      res.json().then((response) => {
        setData(response);
        setLoading(false);
      });
    });
  }

  return (
    <fregment>
      <Header></Header>
      <Sidebar></Sidebar>

      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Commission Summary</h1>
          <div className="seprator"></div>
          <nav className="export-relative">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="javascript:;">Employee Reports</a>
              </li>
              <li className="breadcrumb-item active">Commission Summary</li>
            </ol>
            <a href={api_baseurl+"commission_summary?vendor_id="+vendor_id+"&date_range="+finalDateValue+"&is_download=1"}> <button className="export-data" ><i className="icon-excel"></i> Export Data</button></a>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="top-form">
                    <form>
                      <div className="row">
                        <div className="col date-ic">
                          <label for="selectdate"></label>
                          <DateRangePickerComp
                            alert={parentAlert}
                          ></DateRangePickerComp>
                          {/* <div className="calendar-ic">
                      <button type="button" onClick={getCalendarValue}>
                              <i className="icon-calendar-ic"></i>
                            </button>
                      </div> */}
                          <button
                            type="button"
                            className="go-btn"
                            onClick={getCalendarValue}
                          >
                            Go
                          </button>
                        </div>
                        <div className="col search-ic">
                          <label for="selectdate"></label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            onChange={(e) => setQuery(e.target.value)}
                          />
                          <div className="calendar-ic">
                            <button type="button">
                              <i className="icon-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  {loading ? (
                    ""
                  ) : (
                    <section className="section pst-boxes">
                      <div className="row">
                        <div className="container text-center">
                          <div className="row row-cols-1   row-cols-lg-5 g-3 g-lg-3">
                            <div className="col">
                              <div className="cmn-box">
                                <span>Service Amount</span>
                                <h5>
                                  $
                                  {data.service_amount
                                    ? parseFloat(data.service_amount).toFixed(2)
                                    : "0.00"}
                                </h5>
                              </div>
                            </div>
                            <div className="col">
                              <div className="cmn-box">
                                <span>Service Commission</span>
                                <h5>
                                  $
                                  {data.service_commission
                                    ? parseFloat(data.service_commission).toFixed(2)
                                    : "0.00"}
                                </h5>
                              </div>
                            </div>
                            <div className="col">
                              <div className="cmn-box">
                                <span>Product Amount</span>
                                <h5>
                                  $
                                  {data.product_amount
                                    ? parseFloat(data.product_amount).toFixed(2)
                                    : "0.00"}
                                </h5>
                              </div>
                            </div>
                            <div className="col">
                              <div className="cmn-box">
                                <span>Product Commission</span>
                                <h5>
                                  $
                                  {data.product_commission
                                    ? parseFloat(data.product_commission).toFixed(2)
                                    : "0.00"}
                                </h5>
                              </div>
                            </div>

                            <div className="col">
                              <div className="cmn-box">
                                <span>Total Commission</span>
                                <h5>
                                  $
                                  {data.total_commission
                                    ? parseFloat(data.total_commission).toFixed(2)
                                    : "0.00"}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )}

                  {/*  <!-- Table with stripped rows --> */}
                  {loading ? (
                    <Loader></Loader>
                  ) : (
                    <div className="table-responsive orderid-select">
                      <table
                        class="table table-striped table-bordered"
                        rel="tableRef"
                      >
                        <thead>
                          <tr>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("firstname")}
                              >
                                First Name
                              </a>
                            </th>

                          


                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("lastname")}
                              >
                                Last Name
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("service_completed")}
                              >
                                Service Completed
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("service_amount")}
                              >
                                Service Amount
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("service_commission")}
                              >
                                Service Commission
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("product_sold")}
                              >
                                Product Sold
                              </a>
                            </th>

                            
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("product_amount")}
                              >
                                Product Amount
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("product_commission")}
                              >
                                Product Commission
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("total_commission")}
                              >
                                Total Commission
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.result &&
                            data.result
                              .filter(
                                (item) =>
                                  item.firstname
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.lastname
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.service_completed
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.service_amount
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.service_commission
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.product_sold
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.product_amount
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.product_commission
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.total_commission
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase())
                              )
                              .map((item, index) => (
                                <tr id={index} key={index}>
                                  <td>{item.firstname}</td>
                                  <td>{item.lastname}</td>
                                  <td>{item.service_completed}</td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.service_amount).toFixed(2)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.service_commission).toFixed(2)}
                                  </td>
                                  <td>{item.product_sold?item.product_sold:'0'}</td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.product_amount).toFixed(2)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.product_commission).toFixed(2)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.total_commission).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {/* <!-- End Table with stripped rows --> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer></Footer>
    </fregment>
  );
}

export default CommissionSummary;
